import { env } from '../env';

const BASE_URL = env.apiUrl;

export const api = {
  get: (path: string) => fetch(`${BASE_URL}${path}`),
  post: (path: string, body: unknown) =>
    fetch(`${BASE_URL}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }),
  put: (path: string, body: unknown) =>
    fetch(`${BASE_URL}${path}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }),
  delete: (path: string) => fetch(`${BASE_URL}${path}`, { method: 'DELETE' }),
};
